
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '@/lib/analytics';

interface SEOOptimizerProps {
  children: React.ReactNode;
}

const SEOOptimizer: React.FC<SEOOptimizerProps> = ({ children }) => {
  const location = useLocation();

  useEffect(() => {
    // Track page views for analytics
    const pageTitle = document.title;
    trackPageView(location.pathname, pageTitle);

    // Add structured data for website navigation
    const navigationStructuredData = {
      "@context": "https://schema.org",
      "@type": "SiteNavigationElement",
      "name": "MetroCalma Navigation",
      "url": `https://metrocalma.org${location.pathname}`,
      "inLanguage": "pt-BR"
    };

    // Add to head if not already present
    const existingScript = document.querySelector('script[data-schema="navigation"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.setAttribute('data-schema', 'navigation');
      script.textContent = JSON.stringify(navigationStructuredData);
      document.head.appendChild(script);
    }

    // Optimize images for SEO (add alt attributes if missing)
    const images = document.querySelectorAll('img:not([alt])');
    images.forEach((img) => {
      const imgElement = img as HTMLImageElement;
      if (!imgElement.alt) {
        imgElement.alt = 'MetroCalma - Plataforma de bem-estar mental';
      }
    });

    // Add missing lang attribute to html if not present
    if (!document.documentElement.lang) {
      document.documentElement.lang = 'pt-BR';
    }

  }, [location.pathname]);

  return <>{children}</>;
};

export default SEOOptimizer;
